import App from "./App"

if (window.gtag) {
  window.gtag("config", process.env.REACT_APP_GTAG_ID)
  window.gtagSetPagePath = page_path => {
    window.gtag("config", process.env.REACT_APP_GTAG_ID, {
      page_path: page_path
    })
  }
}

export default App
